import { useEffect, useRef, useState } from 'react';
import { useRevalidator } from 'react-router';
import type { HomeResult } from './homeData';

export function useSettled<T>(promise: Promise<HomeResult<T>>) {
  const [resolved, setResolved] = useState<{ promise: Promise<HomeResult<T>>; result: HomeResult<T> }>();
  useEffect(() => {
    let active = true;
    void promise.then(result => { if (active) setResolved({ promise, result }); });
    return () => { active = false; };
  }, [promise]);
  return { data: resolved?.result.data, error: resolved?.promise === promise ? resolved.result.error : undefined, loading: resolved?.promise !== promise };
}

export function useRevalidateOnReturn() {
  const revalidator = useRevalidator();
  const latest = useRef(revalidator);
  useEffect(() => { latest.current = revalidator; });
  useEffect(() => {
    let last = Date.now();
    const onVisible = () => {
      if (document.visibilityState !== 'visible' || Date.now() - last < 15_000) return;
      last = Date.now();
      if (latest.current.state === 'idle') void latest.current.revalidate();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);
  return revalidator;
}
